module.exports = __webpack_public_path__ + "static/img/pic6.e1043ecf.png";